import { Grid, Skeleton, Stack, Typography } from "@mui/material";
import { useEffect, useState, useRef } from "react";


const OurRecords = ({ title, logo, value , loader }) => {
    const [count, setCount] = useState(0);
    const cardRef = useRef(null);
    const observerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        
        observerRef.current = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    animateCount(0, value, 2000); // Animate over 2 seconds
                }
            },
            { threshold: 0.5 }
        );

        if (cardRef.current) {
            observerRef.current.observe(cardRef.current);
        }

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, [value, isVisible]);

    // Number animation function 
    const animateCount = (start, end, duration) => {
        let startTime = null;

        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            setCount(Math.floor(progress * (end - start) + start));

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        };

        requestAnimationFrame(step);
    };

    return (
        <>
        {
            loader ? (
                <Grid item xs={6} md={3}>
                    <Stack
                        alignItems="center"
                        sx={{
                            boxShadow: 1,
                            borderRadius: 3,
                            padding: { xs: 1, md: 2 },
                        }}
                        spacing={2}
                    >
                        {/* Skeleton for Image */}
                        <Skeleton variant="rectangular" width={90} height={90} />

                        {/* Skeleton for Title */}
                        <Skeleton variant="text" width="60%" height={30} />

                        {/* Skeleton for Count */}
                        <Skeleton variant="text" width="40%" height={30} />
                    </Stack>
                </Grid>
            ) : (
                <Grid item xs={6} md={3} ref={cardRef}>
                    <Stack
                        alignItems="center"
                        sx={{
                            boxShadow: 1,
                            borderRadius: 3,
                            padding: { xs: 1, md: 2 },
                        }}
                        spacing={2}
                    >
                        <img
                            src={logo}
                            style={{ height: "90px", objectFit: "contain" }}
                            alt={title}
                        />
                        <Typography
                            variant='h4'
                            sx={{ textAlign: "center" }}
                            color="#666666"
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant='h3'
                            sx={{ textAlign: "center" }}
                            color="#23a8fa"
                        >
                            {count}
                        </Typography>
                    </Stack>
                </Grid>
            )
        }
        </>
    );
};

export default OurRecords;
